import { render, staticRenderFns } from "./MatrixBaseInfo.vue?vue&type=template&id=00144f2e&"
import script from "./MatrixBaseInfo.vue?vue&type=script&lang=js&"
export * from "./MatrixBaseInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports